import { Grid, Theme } from '@inplayer-org/inplayer-ui';
import styled, { StyledComponent } from 'styled-components';
import StyledContainer from 'components/StyledContainer';

const { Container, Cell } = Grid;

interface DetailsContainerProps {
  fullWidth?: boolean;
}

export const DetailsContainer: StyledComponent<'div', Theme, DetailsContainerProps> = styled.div`
  width: ${({ fullWidth }: DetailsContainerProps) => (fullWidth ? '100%' : '48%')};
`;

interface LabelValueContainerProps {
  halfWidth?: boolean;
}

export const LabelValueContainer: StyledComponent<'div', Theme, LabelValueContainerProps> = styled.div`
  display: flex;
  width: ${({ halfWidth }: LabelValueContainerProps) => (halfWidth ? '50%' : '100%')};
  justify-content: space-between;
`;

export const ButtonContainer = styled(Container)`
  margin-top: 2rem;
`;

export const GrantAccessOptions = styled.div`
  display: flex;
  align-items: center;
`;

export const PeriodsWrapper = styled.div`
  width: fit-content;
`;

export const UtcWrapper = styled(Cell)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

export const AccessPeriodContainer = styled(StyledContainer)`
  min-height: 2.5rem;
`;
